import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { CheckCircle, ArrowRight } from "lucide-react";

export default function ThankYouPage() {
    useEffect(() => {
        // Google Ads conversion tracking
        if (window.gtag) {
            window.gtag('event', 'conversion', {'send_to': 'AW-17745314707/myjOCKKlx9obEJOH0I1C'});
        }
    }, []);

    return (
        <div className="min-h-[70vh] flex items-center justify-center" data-testid="thank-you-page">
            <div className="container mx-auto px-6 lg:px-12 py-20">
                <div className="max-w-lg mx-auto text-center">
                    <div className="w-20 h-20 bg-primary/10 border border-primary/20 flex items-center justify-center mx-auto mb-8">
                        <CheckCircle className="h-10 w-10 text-primary" />
                    </div>
                    <h1 className="font-heading text-4xl sm:text-5xl font-black text-foreground tracking-tight mb-4">
                        Thank You!
                    </h1>
                    <p className="text-muted-foreground text-base sm:text-lg mb-8">
                        Thank you for your inquiry! We will get back to you within 24 hours.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <Link to="/products">
                            <Button className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-none uppercase font-bold tracking-wider px-8">
                                Browse Equipment
                                <ArrowRight className="ml-2 h-4 w-4" />
                            </Button>
                        </Link>
                        <Link to="/">
                            <Button variant="outline" className="rounded-none uppercase font-bold tracking-wider px-8 border-2">
                                Back to Home
                            </Button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
